module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialogs/confirm-dialog/confirm-dialog.component.css
// module id = ./src/app/shared/dialogs/confirm-dialog/confirm-dialog.component.css
// module chunks = main